import styled from "styled-components";

export const StyledContainer = styled.div`
  .ant-btn {
    margin-right: 8px;
    margin-bottom: 12px;
  }
`;
